<app-navbar *ngIf="!(location == '/zoom')"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/zoom')"></app-footer>
<ngx-scrolltop></ngx-scrolltop>
